import { Link } from "react-router-dom";
import { Star } from "lucide-react";

export const ProductCard = ({ product }) => {
  return (
    <Link
      to={`/product/${product.id}`}
      data-testid={`product-card-${product.id}`}
      className="group block bg-white border border-zinc-200 hover:border-black hover:-translate-y-1 hover:shadow-xl transition-all duration-300"
    >
      <div className="aspect-square overflow-hidden bg-zinc-100">
        <img
          src={product.image || "https://placehold.co/600x600/f4f4f5/09090b?text=No+Image"}
          alt={product.title}
          loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="p-5">
        <div className="flex items-center gap-1 mb-2 text-[#FF2A00]">
          <Star size={13} fill="currentColor" />
          <span className="text-xs font-semibold text-zinc-700">{product.rating?.toFixed(1)}</span>
          <span className="text-xs text-zinc-400 ml-2 uppercase tracking-wider">{product.category_slug}</span>
        </div>
        <h3 className="font-display font-medium text-base leading-snug mb-2 line-clamp-2 group-hover:text-[#FF2A00] transition-colors">
          {product.title}
        </h3>
        <div className="font-display font-bold text-lg">{product.price}</div>
      </div>
    </Link>
  );
};
